import { ThemeOptions } from "@mui/material";

export const MuiFormControlLabel = {
  styleOverrides: {
    label: ({ theme }: { theme: ThemeOptions }) => ({
      fontSize: "1rem",
      color: theme?.palette?.text?.primary,
      marginLeft: "12px",
    }),
  },
};
